import styled from 'styled-components';

export const StateMessage = styled.div`
  margin-top: 20px;
  font-size: 14px;
  color: #6b7280;
`;
